<template>
  <div class="main-guide">
    <div class="guide">
      <div class="text-contact">
        <h2>راهنمای سایت</h2>
        <p>
          لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح
          گرافیک
          از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده
          استفاده می نماید.
        </p>

        <p>
          لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح
          گرافیک
          از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده
          استفاده می نماید.لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته
          می‌شود. طراح گرافیک از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی
          طرح
          سفارش گرفته شده استفاده می نماید.
        </p>
      </div>
      <div class="imag">
        <img src="../assets/public/enter1.png" alt="">
      </div>
      <p>
        لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک
        از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده
        استفاده می نماید.
      </p>
      <div class="imag"><img src="../assets/public/otp.png" alt=""></div>
      <p>
        لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک
        از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده
        استفاده می نماید.
      </p>
      <div class="imag"><img src="../assets/public/enter2.png" alt=""></div>
    </div>

    <h2 class="title-blog">
      آخرین مطالب بلاگ
    </h2>
    <div class="last-news">
      <div class="news-box" v-for="(item , index) in items" :key="index">
        <img src="../assets/public/blog-post.png" alt="">
        <p class="title-news-box">
          {{ item.title }}
        </p>
        <p class="content">
          {{ item.content }}
        </p>
        <div class="assets">
          <div class="links">
            <a class="assets-link">
              {{item.like}}
              <img src="../assets/icon/like.png" alt="">
            </a>
            <a class="assets-link">
             {{item.comment}}
              <img src="../assets/icon/comment.png" alt="">
            </a>
          </div>
          <span class="more">مطالعه مطلب</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Guide",
  data() {
    return {
      items: [
        {
          title: 'آموزش معمامله ارز دیجیتال',
          content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، گفته می‌شود',
          like: 5,
          comment: 10
        },

        {
          title: 'آموزش معمامله ارز دیجیتال',
          content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، گفته می‌شود',
          like: 5,
          comment: 10
        },

        {
          title: 'آموزش معمامله ارز دیجیتال',
          content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، گفته می‌شود',
          like: 5,
          comment: 10
        },

        {
          title: 'آموزش معمامله ارز دیجیتال',
          content: 'لورم ایپسوم یا طرح‌نما به متنی آزمایشی و بی‌معنی در صنعت چاپ، گفته می‌شود',
          like: 5,
          comment: 10
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.main-guide {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/backgrounds/rahnama.png");
  background-size: cover;
  background-position: center;
  direction: rtl;

  .guide {
    width: 90%;
    display: flex;
    flex-direction: column;
    gap: 100px;
    direction: rtl;
    text-align: right;
    color: #FBFBFD;
    font-size: clamp(14px, 2vw, 16px);
    margin: 100px 0;

    .text-contact {
      h2 {
        margin-bottom: 50px;
      }
    }

    .imag {
      img {
        width: 100%;
        max-height: 400px;
      }
    }
  }

  .last-news {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 25px;
    width: 90%;
    margin-bottom: 100px;
    flex-wrap: wrap;

    .news-box {
      width: 280px;
      height: auto;
      background: #0B1426;
      box-shadow: 0 0 14px -1px rgba(255, 255, 255, 0.06);
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      text-align: right;
      padding: 20px;
      color: #FBFBFD;
      cursor: pointer;

      img{
        max-height:190px;
        border-radius: 8px;
        width: 100%;
        margin-bottom: 4px;
      }

      .title-news-box{
        margin: 8px 0 !important;
      }
    }

    .links{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 10px;
    }

    .assets{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top:20px;

      .more{
        color: #1199FA;
        font-size:clamp(12px , 2vw , 14px);
      }
      .assets-link{
        display: flex;
        gap: 10px;
        align-items:center;
      }
    }
  }

  .content{
    font-size: clamp(12px , 2vw , 14px);
    color: #D7C8C8;
  }

  .title-blog{
    width: 90%;
    text-align: right;
    color: #FBFBFD;
    margin-bottom: 60px;
  }
}
</style>